import React from 'react';
import Box from '@mui/material/Box';

const TabPanel = (props) => {
  const { children, value, index } = props;

  return (
    <Box
      hidden={value !== index}
      id={`tabpanel-${index}`}
      sx={{ padding: '10px', width: '100%', height: 'calc(100% - 49px)', overflow: 'auto' }}
    >
      {value === index && (
        <>
          {children}
        </>
      )}
    </Box>
  );
};

export default TabPanel;
